import React from 'react';
import { Button, Chip } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';

interface FilterButtonProps {
  filterOpen: boolean;
  onToggleFilter: () => void;
  activeFilterCount: number;
  label?: Field<string> | string;
}

const FilterButton: React.FC<FilterButtonProps> = ({
  filterOpen,
  onToggleFilter,
  activeFilterCount,
  label,
}) => {
  const renderLabel = () => {
    if (!label) return 'Filters';
    if (typeof label === 'string') return label;
    return <Text field={label} />;
  };

  return (
    <Button
      variant="outlined"
      startIcon={<FilterListIcon />}
      endIcon={
        <ExpandMoreIcon
          sx={{
            transform: filterOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s',
          }}
        />
      }
      onClick={onToggleFilter}
      sx={{
        textTransform: 'none',
        borderColor: (theme: any) => theme.palette.themeColor?.main,
        color: (theme: any) => theme.palette.themeColor?.main,
        '&:hover': {
          borderColor: (theme: any) => theme.palette.themeColor?.main,
          backgroundColor: (theme: any) => theme.palette.themeLightColor?.main,
        },
      }}
    >
      {renderLabel()}
      {activeFilterCount > 0 && (
        <Chip
          label={activeFilterCount}
          size="small"
          sx={{
            ml: 1,
            height: 20,
            backgroundColor: (theme: any) => theme.palette.error?.main,
            color: 'white',
          }}
        />
      )}
    </Button>
  );
};

export default FilterButton;
